import React from "react";

import { useSelector } from "../../../utils/hooks";

import SubscriptionDetails from "./SubscriptionDetails";
import SubscriptionHighlight from "./SubscriptionHighlight";
import SubscriptionReadMore from "./SubscriptionReadMore";

import "./SubscriptionInfo.scss";

const SubscriptionInfo = () => {
	const subscription = useSelector(
		(state) => state.popup.products.mainProduct.subscription,
	);

	return (
		<>
			{subscription && (
				<>
					<SubscriptionHighlight isInfoModal={true} />
					<div className="addtocart-subscription-details-wrapper">
						<SubscriptionDetails isInfoModal={true} />
					</div>
					<SubscriptionReadMore />
				</>
			)}
		</>
	);
};

export default SubscriptionInfo;
